export default "__VITE_ASSET__Wk3yUA9P__"